// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DuesAndLedger.css */
.quotes-order-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    background-color: transparent;
  }
  
  .content-wrapper {
    display: flex;
    flex: 1 1;
    overflow: hidden;
    /* padding: 20px;
    gap: 20px; */
    gap: 32px;
    height: calc(100vh - 40px );
  }
  
  /* ClientLeftSection takes 1/3 of the space */
  .client-left-section {
    /* flex: 1; */
    max-width: 33.333%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  /* ItemCard takes remaining 2/3 of the space */
  .client-right-section {
    flex: 2 1;
    /* max-width: 66.667%; */
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  /* Ensure both sections take full height and are independent */
  .client-left-section > *,
  .client-right-section > * {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  
  /* Scrollbar styling */
  .card-content::-webkit-scrollbar,
  .transaction-scroll-container::-webkit-scrollbar {
    width: 8px;
  }
  
  .card-content::-webkit-scrollbar-track,
  .transaction-scroll-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  
  .card-content::-webkit-scrollbar-thumb,
  .transaction-scroll-container::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  
  .card-content::-webkit-scrollbar-thumb:hover,
  .transaction-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
  
  /* Firefox scrollbar */
  .card-content,
  .transaction-scroll-container {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .content-wrapper {
      flex-direction: column;
      padding: 10px;
      height: auto;
    }
    
    .client-left-section,
    .client-right-section {
      flex: none;
      max-width: 100%;
      min-height: 50vh;
      height: 50vh;
    }
  }
  
  
  /* Client Right Section */
  
  .stock {
    display: flex;
    flex-direction: column;
    background: transparent;
    /* border: 1px solid #e2e8f0; */
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    height: -moz-fit-content;
    height: fit-content;
  }
  
  /* Responsive grid adjustments */
  @media (max-width: 1200px) {
    .card-content {
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 14px;
      padding: 14px;
    }
  }
  
  @media (max-width: 768px) {
    .card-content {
      grid-template-columns: 1fr;
      gap: 12px;
      padding: 12px;
    }
    
    .stock {
      padding: 12px;
    }
  }
  
  @media (max-width: 480px) {
    .card-content {
      grid-template-columns: 1fr;
      gap: 10px;
      padding: 10px;
    }
    
    .stock {
      padding: 10px;
    }
  }
  
  /* Your existing stock styles remain the same */
  .stock .right {
    width: 100%;
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    padding: 0px !important;
    cursor: auto;
    gap: 13.5px;
  }
  
  .stock .middle {
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    padding: 0px !important;
    padding-right: 15px !important;
    gap: 15px;
  }
  
  .stock .content {
    display: flex;
    align-items: flex-start;
    justify-items: center;
  }
  
  .stock .content-new {
    display: flex;
    align-items: center !important;
    justify-content: center !important;
  }
  
  .stock .content-new-0 {
    display: flex;
    align-items: flex-start;
    justify-items: center;
  }
  
  .stock .newIcon {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  
  .stock .content-typo {
    display: flex;
    align-items: center;
    font-family: karla !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 22px !important ;
  }
  
  .stock .content-typo-0 {
    display: flex;
    align-items: center;
    font-family: karla !important;
    font-size: 18px !important;
    font-weight: 500;
    line-height: 22px !important;
  }
  
  .stock .content .btn {
    margin-left: auto;
  }
  
  .stock .left {
    position: relative;
    width: 100%;
  }
  
  .stock .left img {
    display: block;
    width: 100%;
    height: 100%;
  }
  
  .stock .left .hoverCheck {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    display: none;
  }
  
  .stock .left.hover-enabled:hover .hoverCheck {
    display: block;
  }
  
  .stock .left .hoverCheck.Mui-checked {
    display: block;
  }
  
  .stock .left button {
    position: absolute;
    bottom: 1px;
    left: 50%;
    transform: translateX(-50%);
    background-color: "#FFFFFF";
    color: #50c878;
    font-weight: 500;
    font-size: 18px;
    text-transform: none;
    padding: 2px;
    border-radius: 5px;
    height: 40px;
    width: 110px;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/features/clients/quote_order_page/QuotesAndOrdersDynamicPage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yGAAyG;IACzG,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB;gBACY;IACZ,SAAS;IACT,2BAA2B;EAC7B;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA,8CAA8C;EAC9C;IACE,SAAO;IACP,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA,8DAA8D;EAC9D;;IAEE,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;;EAGA,sBAAsB;EACtB;;IAEE,UAAU;EACZ;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;;IAEE,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,aAAa;MACb,YAAY;IACd;;IAEA;;MAEE,UAAU;MACV,eAAe;MACf,gBAAgB;MAChB,YAAY;IACd;EACF;;;EAGA,yBAAyB;;EAEzB;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE;MACE,4DAA4D;MAC5D,SAAS;MACT,aAAa;IACf;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,SAAS;MACT,aAAa;IACf;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,SAAS;MACT,aAAa;IACf;;IAEA;MACE,aAAa;IACf;EACF;;EAEA,+CAA+C;EAC/C;IACE,WAAW;IACX,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC;IACtC,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":["/* DuesAndLedger.css */\n.quotes-order-container {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n    background-color: transparent;\n  }\n  \n  .content-wrapper {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n    /* padding: 20px;\n    gap: 20px; */\n    gap: 32px;\n    height: calc(100vh - 40px );\n  }\n  \n  /* ClientLeftSection takes 1/3 of the space */\n  .client-left-section {\n    /* flex: 1; */\n    max-width: 33.333%;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  \n  /* ItemCard takes remaining 2/3 of the space */\n  .client-right-section {\n    flex: 2;\n    /* max-width: 66.667%; */\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  \n  /* Ensure both sections take full height and are independent */\n  .client-left-section > *,\n  .client-right-section > * {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  \n  /* Scrollbar styling */\n  .card-content::-webkit-scrollbar,\n  .transaction-scroll-container::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  .card-content::-webkit-scrollbar-track,\n  .transaction-scroll-container::-webkit-scrollbar-track {\n    background: #f1f5f9;\n    border-radius: 4px;\n  }\n  \n  .card-content::-webkit-scrollbar-thumb,\n  .transaction-scroll-container::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 4px;\n  }\n  \n  .card-content::-webkit-scrollbar-thumb:hover,\n  .transaction-scroll-container::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n  }\n  \n  /* Firefox scrollbar */\n  .card-content,\n  .transaction-scroll-container {\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e1 #f1f5f9;\n  }\n  \n  /* Responsive design */\n  @media (max-width: 768px) {\n    .content-wrapper {\n      flex-direction: column;\n      padding: 10px;\n      height: auto;\n    }\n    \n    .client-left-section,\n    .client-right-section {\n      flex: none;\n      max-width: 100%;\n      min-height: 50vh;\n      height: 50vh;\n    }\n  }\n  \n  \n  /* Client Right Section */\n  \n  .stock {\n    display: flex;\n    flex-direction: column;\n    background: transparent;\n    /* border: 1px solid #e2e8f0; */\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    height: fit-content;\n  }\n  \n  /* Responsive grid adjustments */\n  @media (max-width: 1200px) {\n    .card-content {\n      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n      gap: 14px;\n      padding: 14px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .card-content {\n      grid-template-columns: 1fr;\n      gap: 12px;\n      padding: 12px;\n    }\n    \n    .stock {\n      padding: 12px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .card-content {\n      grid-template-columns: 1fr;\n      gap: 10px;\n      padding: 10px;\n    }\n    \n    .stock {\n      padding: 10px;\n    }\n  }\n  \n  /* Your existing stock styles remain the same */\n  .stock .right {\n    width: 100%;\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    justify-content: flex-start !important;\n    padding: 0px !important;\n    cursor: auto;\n    gap: 13.5px;\n  }\n  \n  .stock .middle {\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: flex-start !important;\n    padding: 0px !important;\n    padding-right: 15px !important;\n    gap: 15px;\n  }\n  \n  .stock .content {\n    display: flex;\n    align-items: flex-start;\n    justify-items: center;\n  }\n  \n  .stock .content-new {\n    display: flex;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n  \n  .stock .content-new-0 {\n    display: flex;\n    align-items: flex-start;\n    justify-items: center;\n  }\n  \n  .stock .newIcon {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n  }\n  \n  .stock .content-typo {\n    display: flex;\n    align-items: center;\n    font-family: karla !important;\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 22px !important ;\n  }\n  \n  .stock .content-typo-0 {\n    display: flex;\n    align-items: center;\n    font-family: karla !important;\n    font-size: 18px !important;\n    font-weight: 500;\n    line-height: 22px !important;\n  }\n  \n  .stock .content .btn {\n    margin-left: auto;\n  }\n  \n  .stock .left {\n    position: relative;\n    width: 100%;\n  }\n  \n  .stock .left img {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .stock .left .hoverCheck {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 24px;\n    height: 24px;\n    border-radius: 5px;\n    display: none;\n  }\n  \n  .stock .left.hover-enabled:hover .hoverCheck {\n    display: block;\n  }\n  \n  .stock .left .hoverCheck.Mui-checked {\n    display: block;\n  }\n  \n  .stock .left button {\n    position: absolute;\n    bottom: 1px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: \"#FFFFFF\";\n    color: #50c878;\n    font-weight: 500;\n    font-size: 18px;\n    text-transform: none;\n    padding: 2px;\n    border-radius: 5px;\n    height: 40px;\n    width: 110px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
